import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagXK(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURSVPpixauCdTqy5dvSlWstivYuG3abDA4dvi7/j4+Hl/jLGbdUlnpTZ60moAAAHxSURBVDjL1Y0xaxwxEIUHla5O7EJCcCHEVrELiyviciUUEtxri7PbVZGkMRjurjQJ3E843B6xi6QzuEuTkOR35c1o12wCNqRL3mpHM/M+zdD8cR3RfwG4UfPKzREq/hGl4dwRaV1pSFrHy/dVtVk57VyBKj2jqogh9+LqXOv1FhV7Dh2ZIALhNAPVestp8TUmyAVtVlo/XV66MRlWz8YJmh/e6wnv0n8J8OR7YUUtiQdQa1/XKDkiZ4nppd1SjdJrPXj7n78OEHoej2YEzPvNqjyvb/I7riFs4Rkzilyvtx43Ts75C4/28dXVRR2jbwntGNfbKMQzAJnJ2gPgTosJ+DYrH1k/Gfgu6evlB/gMjMK7/Y6BMyliI90JAP1gP/cfJ60pcPJJBuT89ncgRJwGA0/yAHQLLAhlR0shBhyEEDuoz/hPQyEgQ03gjPnmpks9Tp/eMA4Daglm4Bz3y9QlVn8mnhCY0FjklhvPYWJC6m6tdMoKa4O1TOHcpaIdm1ZaABi0RYeFWOCFPIJ4wiDg9iCl0+u0G1thAgSJeyl9O1jYiSYTZEe6VYe7RwC6s1apPwBjuaOU4eS6VBwNLogUXuBHCwTt8UWm4CxDVEpFHA2NJmNkxIZHBJ/kEkhkZEIhlCqWmCgM//SA1CR7EPrX9AtZxO5KsLsT6wAAAABJRU5ErkJggg==",
    alt: "XK"
  }, props));
}